<template>
    <div class="collapsible" >
        <div class="trigger">
            <div class="row align-items-center" >
                <div class="col-auto">
                    <div class="trigger-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="24px" height="24px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M17.9 17.39c-.26-.8-1.01-1.39-1.9-1.39h-1v-3a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V7h2a2 2 0 0 0 2-2v-.41a7.984 7.984 0 0 1 2.9 12.8M11 19.93c-3.95-.49-7-3.85-7-7.93c0-.62.08-1.22.21-1.79L9 15v1a2 2 0 0 0 2 2m1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2z" fill="#fff"/></svg>
                    </div>
                </div>
                <div class="col">
                    <div class="trigger-content">Fuentes de Información</div>
                </div>
                <div class="col-auto touchpad" @click="collapse">
                    <div class="trigger-indicator">
                        <font-awesome-icon v-if="hide" icon="chevron-down" style="color:#fff; height:24px"/>
                        <font-awesome-icon v-else icon="chevron-up" style="color:#fff; height:24px"/>
                    </div>
                </div>
            </div>
        </div>
        <div :class="[{'hide':hide},'body']">
            <div class="card head-card news" >
                <div class="title-card">
                  <h4>Noticieros y programas</h4>
                </div>
                <div class="card-content" v-if="noProgramas>0">
                  <div class="checkbox" v-for="(obj,index) in fi" :key="obj.fi">
                    <label :for="obj.fi" v-if="programas[obj.fi]">
                      <input
                        class="box"
                        type="checkbox"
                        :id="obj.fi"
                        :checked="obj.selected"
                        @click="selectMedia(index)"
                      />
                      {{programas[obj.fi].name}}
                      <span class="nbox">
                        <svg viewBox="0 0 14.018 13.003">
                          <path
                            data-name="Rectángulo 9"
                            d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                            transform="translate(-304.98 -380.994)"
                            fill="#fff"
                          />
                        </svg>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="card-content" v-else>
                    <div class="checkbox">
                    <label>No hay seleccionados</label>
                  </div>
                </div>
              </div>  
               <div class="card head-card news">
                <div class="title-card">
                  <h4>Redes Sociales</h4>
                </div>
                <div class="card-content" v-if="noRedes>0">
                    <div class="checkbox iconed" v-for="(obj,index) in fi" :key=obj.id>
                        <label :for="obj.cbox"  v-if="redes[obj.fi]"> 
                            <span class="btn-icon" v-html="obj.html"></span>
                            <input class="box" type="checkbox" :id="obj.cbox"  :checked="obj.selected" @click="selectMedia(index)">
                            {{redes[obj.fi].name}}
                            <span class="nbox">
                                <svg  viewBox="0 0 14.018 13.003">
                                    <path data-name="Rectángulo 9" d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z" transform="translate(-304.98 -380.994)" fill="#fff"/>
                                </svg>
                            </span>
                        </label>
                    </div>
                </div>
                <div class="card-content" v-else>
                    <div class="checkbox">
                    <label>No hay seleccionados</label>
                  </div>
                </div>
              </div>                                 
        </div>
    </div>
</template>

<script>

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTags, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

library.add(faTags)
library.add(faChevronDown)
library.add(faChevronUp)

export default {
    name: 'fiNotes',
    props:['fi'],
    data () {
        return {
            hide:false,
            noProgramas:0,
            noRedes:0,
            programas:{
                'T':{
                    name: 'Programas de televisión',
                },
                'R':{
                    name: 'Programas de radio ',
                },
                'PD':{
                    name: 'Portales de Noticias',
                }
            },
            redes:{
                'TW':{
                    name: 'Twitter',
                    cbox:'cbox-twitter',
                    html:'<svg viewBox="0 0 20 17"><path id="Trazado_308" data-name="Trazado 308" d="M292.779,84.08a8.35,8.35,0,0,1-2.353.68,4.26,4.26,0,0,0,1.811-2.386,8.06,8.06,0,0,1-2.614,1.049,3.979,3.979,0,0,0-3-1.36,4.206,4.206,0,0,0-4.1,4.287,4.751,4.751,0,0,0,.12.98,11.426,11.426,0,0,1-8.461-4.484A4.538,4.538,0,0,0,273.614,85a4.362,4.362,0,0,0,1.822,3.573,3.792,3.792,0,0,1-1.854-.53V88.1a4.283,4.283,0,0,0,.282,1.544,4.162,4.162,0,0,0,3.016,2.651,3.813,3.813,0,0,1-1.085.161,3.448,3.448,0,0,1-.771-.092,4.175,4.175,0,0,0,3.83,3,7.989,7.989,0,0,1-5.088,1.833,9.467,9.467,0,0,1-.987-.058,11.335,11.335,0,0,0,6.291,1.925c6.41,0,10.369-4.714,11.4-9.612a12.5,12.5,0,0,0,.271-2.593V86.3a8.79,8.79,0,0,0,2.039-2.224Z" transform="translate(-272.779 -82.063)" fill="#00b99e" fill-rule="evenodd"/></svg>'
                },
                'FB':{
                    name: 'Facebook',
                    cbox:'cbox-fb',
                    html:`<svg  width="10" height="21" viewBox="0 0 10 21">
                        <g id="Objeto_inteligente_vectorial" data-name="Objeto inteligente vectorial" transform="translate(-46 -836)">
                            <g id="Objeto_inteligente_vectorial-2" data-name="Objeto inteligente vectorial" transform="translate(14.972 808.093)">
                                <path id="Trazado_309" data-name="Trazado 309" d="M37.629,34.2V32.51a.891.891,0,0,1,.94-1h2.4v-3.6H37.664a4.116,4.116,0,0,0-4.5,4.4V34.2H31.028v4.2h2.157V48.907h4.281V38.4h3.167l.139-1.652.255-2.552Z" fill="#262626" fill-rule="evenodd"/>
                            </g>
                            <path id="Color_Overlay" data-name="Color Overlay" d="M48.157,857V846.494H46v-4.2h2.135V840.4a4.115,4.115,0,0,1,4.5-4.4h3.307v3.6h-2.4a.892.892,0,0,0-.94,1v1.686H56l-.255,2.552-.139,1.652H52.438V857Z" fill="#00b99e"/>
                        </g>
                    </svg>`
                },
               /* 'I':{
                    name: 'Instagram',
                    cbox:'cbox-insta',
                    html:` <svg width="24" height="24" viewBox="0 0 24 24" 
                                fill="none"  stroke-width="3" 
                                stroke-linecap="round" stroke-linejoin="round" 
                                class="feather feather-instagram">
                                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                                <line x1="17.5" y1="6.5" x2="17.5" y2="6.5"></line>
                            </svg>`
                },*/
                'Y':{
                    name: 'Youtube',
                    cbox:'cbox-youtube',
                    html:`<svg width="21" height="15" viewBox="0 0 21 15">
                        <image id="youtube" width="21" height="15" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAPCAYAAAALWoRrAAAABHNCSVQICAgIfAhkiAAAARFJREFUOI2t1L0uREEYxvHfGRKFr1Wo2I5OiE5JJKdyEyehWImLcAuiQMRW7kBjE4VSJUIjUfkoBYtChFGclUiw52yy//p5/5PMzPMmMUZJoz6LFUxiDP0YRg8G/KaJTzzhGbe4wm5Ms7PE4d4MTtD3x3CnvGEuoNYloZanFjDVJeE30wHVgtAR7juQVgMqBaED+QNu4qOEtBIwVJSKafYQ02wNszguiPeHEif/lJ/HNJvHfrtcbyfSpFGfwgYWiqRNBVeQNOojWMeqvBDtaAZ5K9qxhEuslRDCY8B1QWgRoyVk39wEXHQwUIaLgC15Z7vBO7aT1paawTImMI5B+Zb67x+/yIvwhFfcybfUTkyz0y8F4EEEvvlVdQAAAABJRU5ErkJggg=="/>
                    </svg>` 
                },
            }
        }
    },
    beforeMount(){
        for(var i in this.fi){
            var fi = this.fi[i].fi;
            if(this.programas[fi]){ this.noProgramas++}
            if(this.redes[fi]){ this.noRedes++}
        }
    },
    methods:{
        selectMedia(ndx){
            this.$emit('selectMedia',ndx);
        },
        collapse(){
            this.hide = !this.hide;
        }
    }
}
</script>

<style scoped>

.button.iconed {
    padding-left: 20px;
}

.chip:hover {
    background:#00B99E;
    fill:#fff;
}


.chip.selectedKeyword:hover {
    background:#EBF9FF;
    fill: #022836;
}



.touchpad{
    cursor: pointer;
}
.selectedKeyword{
   background:#00B99E;
   fill:#fff;
}




.chip.iconed {
    padding-right: 20px;
}
.collapsible .trigger {
    cursor: default;
}
</style>
